import HidingMessageIcon from './HidingMessageIcon'

export default HidingMessageIcon
